const e = {
  openProjectEditDialogEvent: "project-edit-dialog-open-event",
  projectEditDialogProjectUpdatedEvent: "project-edit-dialog-project-updated-event"
}, i = 1e5, o = 3;
function n(t) {
  window.dispatchEvent(
    new CustomEvent(
      e.projectEditDialogProjectUpdatedEvent,
      {
        detail: t
      }
    )
  );
}
function d(t) {
  window.dispatchEvent(
    new CustomEvent(
      e.openProjectEditDialogEvent,
      {
        detail: t
      }
    )
  );
}
export {
  n as dispatchProjectUpdatedEvent,
  i as initialVisibleFieldsCount,
  o as initialVisibleOptionsCount,
  d as openProjectEditDialog,
  e as projectsEditDialogEventKeys
};
